"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const habitnest_models_1 = require("@clearsummit/habitnest-models");
const lodash_1 = require("lodash");
const ApiService_1 = __importDefault(require("../ApiService"));
// import Mixpanel from './mixpanel'
const LOGIN_USER_URL = '/accounts/login/';
const SIGNUP_URL = '/accounts/signup/';
const ME_URL = '/accounts/me/';
const RESET_PASSWORD = '/accounts/reset-password/';
const CHANGE_PASSWORD = '/accounts/change-password/';
const LOGOUT_USER_URL = 'accounts/logout/';
const AUTHENTICATE_FACEBOOK = '/accounts/login-facebook/';
const AUTHENTICATE_GOOGLE = '/accounts/login-google/';
const AUTHENTICATE_APPLE = '/accounts/login-apple/';
const VERIFY_EMAIL_URL = '/accounts/verify-email';
// Payment
const CREATE_PORTAL_SESSION = 'sources/create_portal_session/';
const STRIPE_SUBSCRIPTIONS = 'stripe-subscriptions/';
const STRIPE_SUBSCRIPTIONS_CANCEL = 'stripe-subscriptions/cancel/';
// Habits
const FETCH_ACCOUNT_HABITS = '/account-habits/';
const FETCH_HABIT_JOURNEYS = '/habit_journeys/';
// Wallet Connection
const UPDATE_WALLETS = '/wallet/';
// Nfts
const UPDATE_NFTS = '/nfts/';
// Airbridge
const SET_AIRRIDGE_WEB_INFO = '/accounts/add_airbridge_web_info/';
const axiosAdaptor = (fn, args) => __awaiter(void 0, void 0, void 0, function* () {
    let resp;
    let err;
    try {
        const response = yield fn(args);
        resp = { statusCode: response.status, data: response.data };
    }
    catch (error) {
        const { data } = error.response || {};
        if (data && Array.isArray(data) && data.length > 0) {
            err = { statusCode: data[0].code, details: data[0].description };
        }
        else if ((0, lodash_1.has)(data, 'non_field_errors')) {
            err = { statusCode: 400, details: (0, lodash_1.get)(data, 'non_field_errors')[0] };
        }
        else if (!(0, lodash_1.isEmpty)(data)) {
            // @ts-ignore
            err = { statusCode: data.status, details: data.detail || data.error };
        }
        else {
            // @ts-ignore
            err = { statusCode: data.status, details: data.data.detail };
        }
    }
    return [resp, err];
});
const Api = {
    get: (arg) => axiosAdaptor(ApiService_1.default.get, arg),
    post: (arg) => axiosAdaptor(ApiService_1.default.post, arg),
    put: (arg) => axiosAdaptor(ApiService_1.default.put, arg),
    patch: (arg) => axiosAdaptor(ApiService_1.default.patch, arg),
    delete: (arg) => axiosAdaptor(ApiService_1.default.delete, arg),
};
/**
  * @param {api} ApiService
  * @return Object passed to the api saga, each value must be an asyn function that returns Array<ResponeType, ErrorType>
  * supported by the radio-disptach api-saga
 */
// eslint-disable-next-line max-lines-per-function
const ApiServices = () => {
    // General pagination endpoint
    const getNextPage = (url, responseType) => Api.get({ url, responseType });
    // @ts-ignore
    const login = (data) => Api.post({ url: LOGIN_USER_URL, payload: data, responseType: habitnest_models_1.ModelResponseTypes.User });
    // @ts-ignore
    const signup = (data) => Api.post({ url: SIGNUP_URL, payload: data, responseType: habitnest_models_1.ModelResponseTypes.User });
    // @ts-ignore
    const me = () => Api.get({ url: ME_URL, responseType: habitnest_models_1.ModelResponseTypes.User });
    // @ts-ignore
    const updateMe = (data) => Api.post({ url: ME_URL, payload: data, responseType: habitnest_models_1.ModelResponseTypes.User });
    const getResetPassword = (data) => Api.get({
        url: RESET_PASSWORD,
        // @ts-ignore
        payload: { email: encodeURI(data.email), },
    });
    const postResetPassword = (data) => Api.post({ url: RESET_PASSWORD, payload: data });
    const changePassword = (data) => Api.post({ url: CHANGE_PASSWORD, payload: data });
    const logoutUser = () => { var _a; return Api.post({ url: LOGOUT_USER_URL, payload: { refresh: (_a = ApiService_1.default === null || ApiService_1.default === void 0 ? void 0 : ApiService_1.default.authToken) === null || _a === void 0 ? void 0 : _a.refresh } }); };
    const verifyEmailGet = (data) => Api.get({ url: VERIFY_EMAIL_URL, params: { email: data.username } });
    const verifyEmailPost = (data) => Api.post({ url: VERIFY_EMAIL_URL, payload: { token: data.token } });
    const createPortalSession = () => Api.post({ url: CREATE_PORTAL_SESSION });
    const fetchSubscriptions = () => Api.get({ url: STRIPE_SUBSCRIPTIONS });
    const createSubscription = (data) => Api.post({ url: STRIPE_SUBSCRIPTIONS, payload: data });
    const cancelSubscription = (data) => Api.post({ url: STRIPE_SUBSCRIPTIONS_CANCEL, payload: data });
    const fetchAccountHabits = () => Api.get({ url: FETCH_ACCOUNT_HABITS });
    const fetchHabitJourneys = () => Api.get({ url: FETCH_HABIT_JOURNEYS });
    const fetchWalletAddresses = () => Api.get({ url: UPDATE_WALLETS });
    const fetchNftsAddresses = () => Api.get({ url: UPDATE_NFTS });
    const addWalletAddress = (payload) => Api.post({ url: UPDATE_WALLETS, payload });
    const removeWalletAddress = (id) => Api.delete({
        url: `${UPDATE_WALLETS}${id}/`,
    });
    const authenticateFacebook = (data) => Api.post({
        url: AUTHENTICATE_FACEBOOK,
        payload: data,
        // @ts-ignore
        responseType: habitnest_models_1.ModelResponseTypes.User,
    });
    const authenticateGoogle = (data) => Api.post({
        url: AUTHENTICATE_GOOGLE,
        payload: data,
        // @ts-ignore
        responseType: habitnest_models_1.ModelResponseTypes.User,
    });
    const authenticateApple = (data) => Api.post({
        url: AUTHENTICATE_APPLE,
        payload: data,
        // @ts-ignore
        responseType: habitnest_models_1.ModelResponseTypes.User,
    });
    const saveAirbridgeWebInfo = (payload) => Api.post({ url: SET_AIRRIDGE_WEB_INFO, payload });
    return {
        getNextPage,
        login,
        signup,
        me,
        updateMe,
        getResetPassword,
        postResetPassword,
        changePassword,
        logoutUser,
        verifyEmailGet,
        verifyEmailPost,
        fetchSubscriptions,
        createSubscription,
        cancelSubscription,
        fetchHabitJourneys,
        fetchAccountHabits,
        createPortalSession,
        fetchWalletAddresses,
        fetchNftsAddresses,
        addWalletAddress,
        removeWalletAddress,
        authenticateFacebook,
        authenticateGoogle,
        authenticateApple,
        saveAirbridgeWebInfo
    };
};
const services = ApiServices();
exports.default = services;
